<ion-content>
  <div class="flex flex-col pl-24 pr-24 pb-16">
   <div class="w-100 ion-text-start mt-16" *ngFor="let item of listData" (click)="onClickItem(item)">
     <ion-text class="cursor-ptr hvr-text" [ngClass]="(selectedFilter && selectedFilter.value === item.value) ? 'lbl-sec-bold-14':'lbl-14'">{{ isTraslate ? (item.text | getLanguagePipe) :item.text}}</ion-text></div>
  </div>
</ion-content>